import React, { useState, useContext } from "react";
import {
  Box,
  Button,
  Card,
  Typography,
  CardContent,
  Divider,
} from "@mui/material";
import { ReactComponent as UploadIcon } from "../../../images/uploadIcon.svg";
import { ReactComponent as ExportAuto } from "../../../images/exportAuto.svg";
import * as XLSX from "xlsx";
import TestcaseSelection from "../../popup-components/TestcaseSelection";
import {
  uploadTestCasesAPI,
  modifyTestCaseData,
} from "../../../services/webServices";
import { useNavigate } from "react-router-dom";
import { LoadingModalContext } from "../../main-pages/ServicePage";
import MessagePopup from "../../popup-components/MessagePopup";
import { handleProgressBar } from "../../custom-components/ProgressBar/ProgressBarWithAPI.js"

const APIUploadTestCases = () => {
  const [openTestCasePopup, setOpenTestCasePopup] = useState(false);
  const [testCasesData, setTestCasesData] = useState([]);
  const [uploadedFile, setUploadedFile] = useState("");
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  const { setLoadingState } = useContext(LoadingModalContext);
  const navigate = useNavigate();

  const handleFileUpload = (e) => {
    setLoadingState({ open: true, message: "Standardizing Test Cases", progress: null });
    const file = e.target.files[0];
    if (file) {
      const fileName = file.name.toLowerCase();
      const isExcelXLSX = fileName.endsWith(".xlsx");
      const isExcelXLS = fileName.endsWith(".xls");
      const isCSV = fileName.endsWith(".csv");

      if (!isExcelXLSX && !isExcelXLS && !isCSV) {
        setPopupMessage("Please upload a valid Excel file.");
        setPopupOpen(true);
        return;
      }

      setUploadedFile(file);
      setTestCasesData([]);
      setOpenTestCasePopup(false);

      const reader = new FileReader();

      reader.onload = async (event) => {

        try {
          let jsonData = [];
          let workbook;
          const allResponses = [];


          if (isExcelXLSX || isExcelXLS) {
            const data = new Uint8Array(event.target.result);
            const workbook = XLSX.read(data, { type: "array" });
            const sheetName = workbook.SheetNames[0];
            if (!sheetName) {
              setPopupMessage("The uploaded Excel file has no sheets.");
              setPopupOpen(true);
              //setLoading(false);
              return;
            }
            const worksheet = workbook.Sheets[sheetName];
            jsonData = XLSX.utils.sheet_to_json(worksheet);

          } else if (isCSV) {
            const text = event.target.result;
            const workbook = XLSX.read(text, { type: "string" });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            jsonData = XLSX.utils.sheet_to_json(worksheet);

          }

          if (!jsonData.length) {
            setPopupMessage("The Excel file is empty or has invalid format.");
            setPopupOpen(true);
            //  setLoading(false);
            return;
          }
          // for (const testCase of jsonData) {
          //   try {
          //     const response = await uploadTestCasesAPI(testCase);
          //     if (response?.data) {
          //       allResponses.push(response.data);
          //     }
          //   } catch (err) {
          //     console.error("Error processing a test case:", err);
          //     // Optionally continue even if one fails
          //   }
          // }
          function chunkArray(array, size) {
            const result = [];
            for (let i = 0; i < array.length; i += size) {
              result.push(array.slice(i, i + size));
            }
            return result;
          }

          const batches = chunkArray(jsonData, 5);

          for (const batch of batches) {
            try {
              const response = await uploadTestCasesAPI(batch); // send 5 test cases at once
              if (response?.data) {
                allResponses.push(response.data);
              }
            } catch (err) {
              console.error("Error processing a batch of test cases:", err);
              // setPopupMessage("Error processing some test cases. Please check the file format and try again.");
              // setPopupOpen(true);
            }
          }

          if (allResponses.length === 0) {
            setPopupMessage("No valid test cases found in the file.");
            setPopupOpen(true);
            return;
          }

          // If the API returns individual objects, flatten the array
          const testcasesflat = allResponses.flat();
          setTestCasesData(testcasesflat);
          console.log("Test cases data:", testcasesflat);

          setOpenTestCasePopup(true);
          navigate("/dashboard/api-testing/choose-testcase", {
            state: { testCaseData: testcasesflat },
          });

          setOpenTestCasePopup(true);
        } catch (error) {

          setLoadingState({ open: false, message: "", progress: null });
          // setPopupMessage("Something went wrong while importing the file.");
          // setPopupOpen(true);

        } finally {
          // setLoading(false);
          setLoadingState({ open: false, message: "", progress: null });

        }
      };

      reader.onerror = () => {
        setPopupMessage("Failed to read the file. Please try again.");
        setPopupOpen(true);
      };

      if (isExcelXLSX || isExcelXLS) {
        reader.readAsArrayBuffer(file);
      } else if (isCSV) {
        reader.readAsText(file);
      }

      setUploadedFile("");
    }
  };

  const handleUploadedTestCases = () => {
    //  navigate("/dashboard/api-testing/choose-testcase", {
    //   state: { testCaseData: testCasesData  },
    // });
  }

  return (
    <Box display="flex" justifyContent="center" mt={8}
      sx={{

        px: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }, // Padding for all screen sizes
      }}
    >
      <Card sx={{ width: "90%", borderRadius: 2, boxShadow: 3, }}>
        <CardContent>
          <Typography variant="h6" gutterBottom mb={4}>
            Test case details
          </Typography>

          <Box display="flex" alignItems="center" gap={1} mb={6}>
            <Button
              startIcon={<UploadIcon />}
              component="label"
              sx={{ textTransform: "none", color: "#49A3FF", fontSize: "16px" }}
            >
              Upload
              <input
                hidden
                type="file"
                value={uploadedFile}
                accept=".xlsx, .xls, .csv"
                onChange={handleFileUpload}
              />
            </Button>
            <Typography variant="body2" fontSize={16}>Test case document</Typography>
          </Box>

          {/* <Box>
            <Typography variant="body2" color="text.secondary" fontSize={12} mb={1} >
              The uploaded Excel file must include the following columns: <br />
              Test Case ID, Test Case Title, API Endpoint, Method, Test Description, Test Steps, Input Data, Expected Result, Category, Sub-Category.<br />
              Category should specify whether it is <strong>Functional</strong> or <strong>Non-Functional</strong> testing. Sub-Category should describe the specific area it belongs to.
            </Typography>
          </Box> */}

          <Divider />

          <Box display="flex" justifyContent="space-between" mt={2}>
            <Button

              startIcon={<ExportAuto disabled />}
              disabled
              sx={{ textTransform: "none", color: "#49A3FF" }}

            >
              Import from Jira
            </Button>
            {/* <Button variant="contained"
              disabled={!testCasesData.length}
              onClick={handleUploadedTestCases}
            >
              Continue
            </Button> */}
          </Box>
        </CardContent>
      </Card>
      <MessagePopup
        modalOpen={popupOpen}
        okayHandler={() => setPopupOpen(false)}
        message={popupMessage}
      />
    </Box>
  );
};

export default APIUploadTestCases;
